import { COLUMN_CATEGORY, COLUMN_COMPANY, COLUMN_DAYS, COLUMN_DEPARTMENT, COLUMN_DISPLAY_NAME, COLUMN_FIRST_NAME, COLUMN_LAST_NAME, COLUMN_SECOND_NAME, COLUMN_SUFFIX, COLUMN_TITLE, COLUMN_UNIQUE_IDENTIFIER } from "../../constants/column-types";
import { FILTER_TAGHOLDER_TYPE, FILTER_COMPANIES, FILTER_DEPARTMENTS, FILTER_TAGHOLDERS } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const FirstInLastOutReportColumn: TableColumn[] = [
    {
        heading: "Display Name",
        accessor: "displayName",
        sortDirection: "asc",
        sortByName: "master.mstDisplayname",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "displayName",
        columnId: COLUMN_DISPLAY_NAME,
        lookupName: "master.mstDisplayname",
        searchOnName: "master.id",
        filterId: FILTER_TAGHOLDERS,
        settingDataName: 'master'
    },
    {
        heading: "First Name",
        accessor: "firstName",
        isNumeric: false,
        sortDirection: "asc",
        sortByName: "master.mstFirstname",
        id: 2,
        active: false,
        translationKey: "firstName",
        columnId: COLUMN_FIRST_NAME
    },
    {
        heading: "Second Name",
        accessor: "middleName",
        sortDirection: "asc",
        sortByName: " master.mstMiddlename",
        isNumeric: false,
        id: 3,
        active: false,
        translationKey: "secondName",
        columnId: COLUMN_SECOND_NAME
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        isNumeric: false,
        sortDirection: "asc",
        sortByName: "master.mstLastname",
        id: 4,
        active: false,
        translationKey: "lastName",
        columnId: COLUMN_LAST_NAME
    },
    {
        heading: "Unique Identifier",
        accessor: "uniqueIdentifier",
        isNumeric: false,
        sortDirection: "asc",
        sortByName: "master.mstIdnumber",
        id: 5,
        active: false,
        translationKey: "uniqueIdentifier",
        columnId: COLUMN_UNIQUE_IDENTIFIER
    },
    {
        heading: "Suffix",
        accessor: "suffix",
        isNumeric: false,
        sortDirection: "asc",
        sortByName: "master.mstSuffix",
        id: 6,
        active: false,
        translationKey: "suffix",
        columnId: COLUMN_SUFFIX
    },
    {
        heading: "Title",
        accessor: "title",
        isNumeric: false,
        sortDirection: "asc",
        sortByName: "master.mstTitle",
        id: 7,
        active: false,
        translationKey: "title",
        columnId: COLUMN_TITLE
    },
    {
        heading: "Category",
        accessor: "categoryType",
        isNumeric: false,
        id: 8,
        sortDirection: "asc",
        searchOnName: "master.profile.id",
        lookupName: "nameOriginal",
        sortByName: "master.profile.trnName",
        active: false,
        translationKey: "category",
        columnId: COLUMN_CATEGORY,
        filterId: FILTER_TAGHOLDER_TYPE,
        settingDataName: "profile"
    },
    {
        heading: "Company",
        accessor: "compName",
        isNumeric: false,
        id: 9,
        searchOnName: "master.company.id",
        lookupName: "master.company.id",
        sortByName: "master.company.compName",
        sortDirection: "asc",
        active: false,
        translationKey: "company",
        columnId: COLUMN_COMPANY,
        filterId: FILTER_COMPANIES,
        settingDataName: "company"
    },
    {
        heading: "Department",
        accessor: "deptName",
        isNumeric: false,
        searchOnName: "master.department.id",
        lookupName: "master.department.id",
        sortByName: "master.department.deptName",
        sortDirection: "asc",
        id: 10,
        active: false,
        translationKey: "department",
        columnId: COLUMN_DEPARTMENT,
        filterId: FILTER_DEPARTMENTS,
        settingDataName: "department"
    },
]

export default FirstInLastOutReportColumn;
